import styled from 'styled-components'

const Heading = styled.h2`
  font-size: 45px;
  margin: .825rem 0 2rem;
  line-height: 1;
  font-weight: 100;
  color: ${props => props.color || '#15405C'};
`

const HalfWidthHeading = styled(Heading)`
  width: 100%;

  @media screen and (min-width: 1024px) {
    width: 60%;
  }
`;

const H1 = styled.h1`
  color: ${props => props.color || '#15405C'};
  font-size: 2.6rem;

  @media screen and (min-width: 1024px) {
    font-size: 4.642rem;
  }
`

const H2 = styled.h2`
  font-size: 45px;
  margin: .825rem 0 2rem;
  line-height: 1;
  font-weight: 100;
  color: ${props => props.color || '#15405C'};
`

const H3 = styled.h3`
  font-size: 1.4285rem;
  font-weight: 400;
  color: ${props => props.color || '#15405C'};
`

const Paragraph = styled.p`
  font-size: 18px;
  color: ${props => props.color || '#15405C'};
  margin: ${({ margin }) => margin || 0};
  white-space: ${({ whiteSpace }) => whiteSpace || 'normal'};
`

const ParagraphSica = styled(Paragraph)`
  font-family: 'Sica', sans-serif;
  line-height: 1.5;
`

const ParagraphSmall = styled(ParagraphSica)`
  font-size: 0.9375rem;
`;

const ParagraphWrap = styled(ParagraphSica)`
  white-space: pre-wrap;
  text-align: ${({textAlign}) => textAlign || 'center' };
`;

export {
  Heading,
  HalfWidthHeading,
  H1,
  H2,
  H3,
  Paragraph,
  ParagraphSica,
  ParagraphSmall,
  ParagraphWrap,
}
